import type { DiscountAppliedTo } from "../enums/DiscountAppliedTo"
import type { UserMiniEntity } from "@/features/user/domain/entities/UserMiniEntity"
import type { BranchMiniEntity } from "@/features/branch/domain/entities/BranchMiniEntity"
import type { UserGroupEntity } from "@/features/userGroup/domain/entities/UserGroupEntity"
import type { ChannelMiniEntity } from "@/features/channel/domain/entities/ChannelMiniEntity"
import type { ServiceMiniEntity } from "@/features/service/domain/entities/ServiceMiniEntity"

export class CampaignsFilterEntity {
    dateRange ?: string[]  
    page?: number 
    limit?: number 
    user?: UserMiniEntity 
    branch?: BranchMiniEntity 
    excludedBranch?: BranchMiniEntity 
    numberOfSteps?: number 
    group?: UserGroupEntity 
    channel?: ChannelMiniEntity 
    service?: ServiceMiniEntity 
    hasStepWithAppliedTo?: Array<DiscountAppliedTo>  
}
